import { render, staticRenderFns } from "./SwitchLang.vue?vue&type=template&id=113ed462&"
import script from "./SwitchLang.vue?vue&type=script&lang=js&"
export * from "./SwitchLang.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports